import React, { } from 'react';
import { UserSelectionProvider } from './providers/UserSelectionProvider';
import { UiStateProvider } from './providers/UiStateProvider';
import { CustomAppShell } from './components/Navigation/CustomAppShell';
import { DataProvider } from './providers/DataProvider';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { PathExplorerProvider } from './providers/PathExplorerProvider';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import Welcome from './pages/Welcome';
import Search from './pages/Search';
import Rankings from './pages/Rankings';
import Evidence from './pages/Evidence';
import PathExplorer from './pages/PathExplorer';
import StandalonePathExplorer from './pages/StandalonePathExplorer';
import { StandalonePathExplorerProvider } from './providers/StandalonePathExplorerProvider';

function MainApp() {
  return (
    <UserSelectionProvider>
      <DataProvider>
        <UiStateProvider>
          <PathExplorerProvider>
            <Routes>
              <Route path="/" element={<CustomAppShell />}>
                <Route index element={<Search />} />
                <Route path="rankings" element={<Rankings />} />
                <Route path="evidence" element={<Evidence />} />
                <Route path="kg" element={<PathExplorer />} />
              </Route>
            </Routes>
          </PathExplorerProvider>
        </UiStateProvider>
      </DataProvider>
    </UserSelectionProvider>
  );
}

export function App() {
  return (
    <MantineProvider>
      
        <Notifications zIndex={2077} />
        <Router>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/path-explorer" element={
              <StandalonePathExplorerProvider>
                <StandalonePathExplorer />
              </StandalonePathExplorerProvider>} />
            <Route path="/app/*" element={<MainApp />} />
          </Routes>
        </Router>
    </MantineProvider>
  );
}
